import { useLoginMutation } from 'src/api/auth';
import { companyName } from 'src/config';
import { validateEmail, validateEmpty } from 'src/helpers/validators';

export type FormData = {
  email: string;
  password: string;
};

const initialValues: FormData = {
  email: '',
  password: '',
};

const validate = {
  email: (value: string) => validateEmail(value),
  password: (value: string) => validateEmpty(value, 'Please enter password'),
};

export const useLogin = () => {
  const { loginMutation, isPending: isLoginPending } = useLoginMutation();

  const isLoading = isLoginPending;

  const title = `Welcome to ${companyName}'s Playwall`;
  const subtitle = 'Sign in';

  return {
    initialValues,
    isLoading,
    onSubmit: (values: FormData) => loginMutation(values),
    subtitle,
    title,
    validate,
  };
};
